import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { useSalesModel } from "../salesModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useSalesDetailModel } from "./details/salesDetailModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export const DataBox = () => {
    const { selectedRowKeys, exportSales, disableSales, dataSource } = useSalesModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { updateFormVal } = useSalesDetailModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let salesEditKey = "3-2";
        let isFindNav = findNav(salesEditKey);
        if (!isFindNav) {
            addNav(salesEditKey, { id: selectedRowKeys[0], mode: "edit" });
            updateFormVal("edit", null);
        } else {
            globalPrompt("modal", {
                title: "外贸合同跳转详情",
                type: "warning",
                text: "您还有外贸合同详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(salesEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateFormVal("edit", null);
                }
            })
        }
    }

    const onAdd = () => {
        addNav("3-1", { id: "", mode: "add" })
        updateFormVal("add", null);
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.S_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onAdd}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要作废的单据");
                        return;
                    }
                    const row = dataSource.find(item => item.code === selectedRowKeys[0])
                    if (row?.status !== DictCodeEnmu.SALES_INIT) return globalPrompt('message', { text: '此状态不可作废', type: 'warning' })
                    globalPrompt("modal", {
                        title: "外贸合同作废",
                        text: ` `,
                        onOk: () => disableSales(selectedRowKeys[0]),
                    })
                }}
            >作废</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_ED_EXPORT}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportSales()}
            >导出</Button>
        </YhAuth>

    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}